import { render } from "./holidays.vue?vue&type=template&id=b8d62aa4&scoped=true"
import script from "./holidays.vue?vue&type=script&lang=js"
export * from "./holidays.vue?vue&type=script&lang=js"

import "./holidays.vue?vue&type=style&index=0&id=b8d62aa4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8d62aa4"]])

export default __exports__